import { render, staticRenderFns } from "./ReturnDetails.vue?vue&type=template&id=1aadd17c&scoped=true"
import script from "./ReturnDetails.vue?vue&type=script&lang=js"
export * from "./ReturnDetails.vue?vue&type=script&lang=js"
import style0 from "./ReturnDetails.vue?vue&type=style&index=0&id=1aadd17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aadd17c",
  null
  
)

export default component.exports